const PLANS = {
  free: {
    key: "free",
    name: "Free Trial",
    show: "Free Trial",
    label: "Free Trial",
    videoMax: 1,
    tokenTotal: 50000,
    trialDays: 1,
  },
  executive: {
    key: "executive",
    name: "Executive",
    show: "Executive",
    label: "Executive Plan",
    priceId: "price_1RUtZWCX9dGEuSNBL7bXvOEX",
    productId: "prod_SPj1E6d5ujZHxA",
    price: 5,
    billingInterval: "month",
    priceLabel: "$5/month",
    videoMax: 1,
    tokenTotal: 50000,
  },
  professional: {
    key: "professional",
    name: "Professional",
    show: "Professional",
    label: "Professional Plan",
    priceId: "price_1RUu9FCX9dGEuSNB1uS3PmEA",
    productId: "prod_SPjcU5FJHeaQu3",
    price: 14,
    billingInterval: "month",
    priceLabel: "$14/month",
    videoMax: 4,
    tokenTotal: 1000000,
  },
  enterprise: {
    key: "enterprise",
    name: "Enterprise",
    show: "Enterprise",
    label: "Enterprise Plan",
    priceId: "price_1TkQ2GCX9dGEuSNBwJ15gbc2",
    productId: "prod_UjtpQTWFLNlPO0",
    price: 3000,
    billingInterval: "quarter",
    priceLabel: "$3,000/quarter",
    videoMax: 100,
    tokenTotal: 10000000,
  },
  condense: {
    key: "condense",
    name: "Condense Access",
    show: "Condense Access",
    label: "Condense Access",
    priceId: import.meta.env.VITE_CONDENSE_STRIPE_PRICE_ID || "",
    productId: import.meta.env.VITE_CONDENSE_STRIPE_PRODUCT_ID || "",
    price: 199,
    firstQuarterPrice: 99,
    billingInterval: "quarter",
    priceLabel: "$199/quarter",
    firstQuarterPriceLabel: "$99 first quarter",
    videoMax: 4,
    tokenTotal: 0,
  },
};

const PLAN_TIER_ORDER = ["free", "executive", "professional", "enterprise", "condense"];

/** Self-serve Condense trial defaults — keep in sync with backend DEFAULT_ACCOUNT_PRICING */
const CONDENSE_TRIAL = {
  evaluationHours: 3,
  extensionHours: 1,
};

function planAtLeast(plan, minTier) {
  const p = (plan || "free").toLowerCase();
  const min = (minTier || "free").toLowerCase();
  return PLAN_TIER_ORDER.indexOf(p) >= PLAN_TIER_ORDER.indexOf(min);
}

export { PLANS, PLAN_TIER_ORDER, planAtLeast, CONDENSE_TRIAL };
